<div class="modal-content">
  <div class="modal-header">
    <p class="modal-title"><strong>{{getDialogTitle() | translate}}</strong></p>
    <button type="button" class="close" (click)="closeDialog(false)" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <mat-dialog-content style="overflow:visible">
      <form (ngSubmit)="save()" #f="ngForm" id="form"
            [formGroup]="formGroup" novalidate>

        <div class="row form-group"
             [ngClass]="{ 'has-danger': hasLocalFieldError('invoiceTag') || hasFieldError(ValidatedField.INVOICE_TAG)}">
          <label
            class="col-form-label form-control-label col-md-4 detail-title"
            [class.required-field-label]="true">{{'INVOICE_TAG_INVOICE_TAG' | translate}}</label>
          <div class="col-md-8">
            <div class="mw-100">
              <input type="text"
                     [(ngModel)]="model.invoiceTag"
                     [ngClass]="{ 'form-control-danger': hasLocalFieldError('invoiceTag') || hasFieldError(ValidatedField.INVOICE_TAG) }"
                     trim="blur"
                     validateOnBlur
                     class="form-control"
                     name="invoiceTag"
                     id="invoiceTag"
                     formControlName="invoiceTag"
                     (ngModelChange)="removeFieldError(ValidatedField.INVOICE_TAG)"
                     placeholder="{{'INVOICE_TAG_INVOICE_TAG'|translate}}">
              <div class="form-control-feedback" *ngIf="hasLocalFieldError('invoiceTag')">
                {{'COMMON_VALIDATION_MESSAGE_REQUIRED' | translate}}
              </div>
              <div class="form-control-feedback" *ngIf="hasFieldError(ValidatedField.INVOICE_TAG)">
                {{getFieldErrorText(ValidatedField.INVOICE_TAG)}}
              </div>
            </div>
          </div>
        </div>
        <div class="row form-group"
             [ngClass]="{ 'has-danger': hasFieldError(ValidatedField.DESCRIPTION)}">
          <label
            class="col-form-label form-control-label col-md-4 detail-title">{{'COMMON_DESCRIPTION' | translate}}</label>
          <div class="col-md-8">
            <div class="mw-100">
              <input type="text"
                     [(ngModel)]="model.description"
                     [ngClass]="{ 'form-control-danger': hasFieldError(ValidatedField.DESCRIPTION) }"
                     trim="blur"
                     validateOnBlur
                     class="form-control"
                     name="description"
                     id="description"
                     formControlName="description"
                     (ngModelChange)="removeFieldError(ValidatedField.DESCRIPTION)"
                     placeholder="{{'COMMON_DESCRIPTION'|translate}}">
              <div class="form-control-feedback" *ngIf="hasFieldError(ValidatedField.DESCRIPTION)">
                {{getFieldErrorText(ValidatedField.INVOICE_TAG)}}
              </div>
            </div>
          </div>
        </div>
      </form>

      <div *ngIf="invoiceTag">
        <div class="row form-group">
          <label
            class="col-form-label form-control-label col-md-4 detail-title">{{'COMMON_TABLE_HEADER_CREATION_TIME' | translate}}</label>
          <div class="col-md-8">
            <div class="mw-100">
              <label class="form-control detail-input">{{invoiceTag.creationTime.toUtcIsoString() | date:'short'}}</label>
            </div>
          </div>
        </div>
        <div class="row form-group">
          <label
            class="col-form-label form-control-label col-md-4 detail-title">{{'COMMON_TABLE_HEADER_UPDATE_TIME' | translate}}</label>
          <div class="col-md-8">
            <div class="mw-100">
              <label class="form-control detail-input">{{invoiceTag.updateTime.toUtcIsoString() | date:'short'}}</label>
            </div>
          </div>
        </div>
      </div>
    </mat-dialog-content>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-outline-primary" (click)="closeDialog(false)">
      {{'COMMON_BUTTON_CANCEL' | translate}}
    </button>
    <button type="submit" class="btn btn-primary" form="form">
      {{'COMMON_BUTTON_SAVE' | translate}}
    </button>
  </div>
</div>
